import { render, staticRenderFns } from "./SimpleWeeklySchedule.vue?vue&type=template&id=2d96ceb3&scoped=true"
import script from "./SimpleWeeklySchedule.vue?vue&type=script&lang=js"
export * from "./SimpleWeeklySchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96ceb3",
  null
  
)

export default component.exports